import { put, takeEvery } from 'redux-saga/effects';
import request from 'utils/request';
import urls from 'utils/config';
import { checkOrgSuccess, checkOrgFailed } from '../actions';
import { OrganizationTypes } from '../types';
import {
  getAuthOrganisationId,
  isAuthOrganisationMismatch,
  setOrgRoutingKeys,
} from 'utils/portalSlug';
import { errorNotifier, logout } from 'utils/helpers';
import {
  getCachedOrgLookup,
  setCachedOrgLookup,
} from 'utils/orgLookupCache';

const { API_BASE_URL } = urls || {};

function* applyOrgPayload(payload, cb) {
  const canonicalId = payload.id || '';
  if (getAuthOrganisationId() && canonicalId && isAuthOrganisationMismatch(canonicalId)) {
    errorNotifier(
      'You are signed in to a different organisation. Please sign in again for this portal.'
    );
    logout();
    return;
  }
  setOrgRoutingKeys(canonicalId, payload.portalAlias);
  if (cb) {
    cb(payload);
  }
  yield put(checkOrgSuccess(payload));
}

export function* checkOrgExistence({ data: { id, cb } }) {
  const cached = getCachedOrgLookup(id);
  if (cached) {
    yield* applyOrgPayload(cached, cb);
    return;
  }

  const url = `${API_BASE_URL}/portals/${encodeURIComponent(id)}/organisation`;

  const response = yield request({
    method: 'get',
    url,
    cacheTtl: 5 * 60 * 1000,
  });
  if (response.success && response.statusCode === 200) {
    const org = response.raw || {};
    const canonicalId = org.id || '';
    const portalAlias = org.portalAlias || canonicalId;
    const payload = {
      id: canonicalId,
      portalAlias,
      name: org.name,
      logoUrl: org.logoUrl,
      courseAlias: org.courseAlias,
    };
    setCachedOrgLookup(id, payload);
    yield* applyOrgPayload(payload, cb);
    return;
  }
  if (response.statusCode === 404) yield put(checkOrgFailed());
}

export function* orgCheck() {
  yield takeEvery(OrganizationTypes.CHECK_ORG_EXISTS, checkOrgExistence);
}
